





import Vue from 'vue'
import Student from '@/models/Students/Student'
import {MSGRS} from '../msgrsList.vue'
export default Vue.extend({
  props: {
    msgr: String,
    scope: {} as () => {student: Student}
  },
  methods: {
    async disableMsgr (): Promise<void> {
      try {
        // @ts-ignore
        await this.$confirm(`${this.$t('students.messenger.really_want_disable')} ${this.getMsgrLabel()}`, this.$t('labels.attention'), {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })
        await this.$store.dispatch('students/dropMsgrs', {stud_id: this.scope.student.getId(), msgrs: [this.msgr]})
        await this.$store.dispatch('students/loadStudent', this.scope.student.getId())
        this.$message({
          message: `${this.$t('students.messenger.messenger')} ${this.getMsgrLabel()} ${this.$t('students.messenger.disable2')}`,
          type: 'success'
        });
      } catch (error) {
        if (error.type) {
          // @ts-ignore
          this.$message.error(this.$t('students.messenger.can_not_disable'));
          console.log('LOG: disableMsgr', error)
        }
      }
    },
    getMsgrLabel () {
      return MSGRS[this.msgr].label;
    }
  }
})
